import React from 'react';
import { Box } from '@mui/material';
import { SignUp } from '@clerk/clerk-react';

/**
 * AUTH-4 — hosted Clerk sign-up (path routing under /sign-up/*). Providers are
 * configured in the Clerk dashboard (ADR-007). Only mounted when
 * REACT_APP_AUTH_ENABLED is on (see App.js).
 */
export default function SignUpPage() {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
            <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
        </Box>
    );
}
